// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"2f0eb5bc","287":"173d4f4c","299":"8419ecd6","453":"87e32a49","537":"0b5fda6a","606":"a89794f0","991":"9efc4982"}[chunkId] + ".chunk.js";
};